import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const { pathname } = useLocation();

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <Link to="/" className="navbar-brand">First Gradient</Link>
      <ul className="navbar-links">
        {[
          ['/', 'Home'],
          ['/about', 'About Us'],
          ['/services', 'Services'],
          ['/edh', 'EDH Platform'],
          ['/contact', 'Contact Us'],
        ].map(([path, label]) => (
          <li key={path}>
            <Link to={path} className={pathname === path ? 'active' : ''}>{label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
